import projection from '../generated/pwj220f1.json';
import type { AcceptanceManifest } from '../types';

export const pwj220f1AcceptanceManifest = projection as AcceptanceManifest;
